import gql from 'graphql-tag';
import { clients } from '../../util/clients';

const { backend } = clients.direct;

export const systemInfo = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    async backendStorageStats({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query backendStorageStats ($criteria: BackendStorageStatsCriteriaType) {
            backendStorageStats(criteria: $criteria)
            {
              pvcRawResult
              pvcRawParsedResult
              backendDataFilesUsedPercentage
            }
          }`,
          variables: {
            criteria,
          },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        let backendStorageStatsDetails;
        if (results.data && results.data.backendStorageStats) {
          backendStorageStatsDetails = results.data.backendStorageStats;
        }
        return backendStorageStatsDetails || {};
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the backend storage stats.', { root: true });
      }
      return {};
    },
  },
};

export default systemInfo;
